// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination-module--wrapper--36uc2","titleWithButton":"Pagination-module--titleWithButton--2f7xV"};